<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="700">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          height="100%"
          v-bind="attrs"
          v-on="on">
          ログイン
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          ログイン
        </v-card-title>
        <v-card-text style="text-align: center;">
          <v-btn
            class="mx-2 my-4"
            color="red white--text"
            style="text-transform: none"
            @click="clickLoginGoogle">
            Googleアカウントでログイン
          </v-btn>
          <v-btn
            color="indigo darken-1 white--text"
            style="text-transform: none"
            @click="clickLoginFacebook">
            Facebookアカウントでログイン
          </v-btn>
        </v-card-text>
        <v-divider />
        <v-card-text class="my-4">
          <v-form ref="form">
            <v-text-field
              v-model="email"
              label="メールアドレス【必須】"
              placeholder="example@example.com"
              :rules="[required]" />
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[required, min, format]"
              :type="showPassword ? 'text' : 'password'"
              name="input-password"
              label="ログインパスワード"
              hint="6文字以上の半角英数字で入力してください"
              autocomplete="off"
              counter
              @click:append="showPassword = !showPassword" />
          </v-form>
        </v-card-text>
        <v-card-text style="text-align: center;">
          <div
            v-if="$store.state.errorMessage"
            style="color: red;">
            <p>エラー：{{ $store.state.errorMessage }}</p>
          </div>
          <v-btn
            class="mx-2"
            color="info"
            @click="validate">
            ログイン
          </v-btn>
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false">
            キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import firebase from '@/plugins/firebase'

export default {
  data() {
    return {
      dialog: false,
      showPassword: false,
      email: '',
      password: '',
      required: (v) => !!v || '必須入力です',
      min: (v) =>
        v && v.length >= 6 || 'パスワードは6文字で入力してください',
      format: (v) =>
        /^[\w-]{6,72}$/.test(v) ||
                'パスワードは半角英数字で入力してください',
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    dialog: function (newVal, oldVal) {
      if (!newVal) {
        this.setErrorMessage('')
      }
    }
  },
  methods: {
    async validate() {
      this.isInputValid = this.$refs.form.validate()
      // validationでエラーがなければ、確認ダイアログを開く
      if (this.isInputValid) {
        try {
          const providers = await firebase.auth().fetchSignInMethodsForEmail(this.email)
          if (providers.findIndex(p => p == firebase.auth.GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD) !== -1 ||
          providers.findIndex(p => p == firebase.auth.FacebookAuthProvider.PROVIDER_ID) !== -1
          ) {
            this.setErrorMessage('メールアドレスはGoogleまたはFacebookアカウントで登録されています。')
            return
          }
          this.loginUserByEmailAndPassword({ email: this.email, password: this.password })
        } catch (error) {
          //console.error('validate error:', error)
          return 'エラー'
        }
      }
    },
    clickLoginGoogle() {
      this.loginGoogle()
    },
    clickLoginFacebook() {
      this.loginFacebook()
    },
    ...mapActions([
      'loginUserByEmailAndPassword',
      'loginGoogle',
      'loginFacebook',
      'setErrorMessage'
    ]),
  },
}
</script>
